// eslint-disable-next-line import/prefer-default-export
export const SIGNUP_FOR = {
  candidate: 'candidate',
  apply: 'apply',
  cv_builder: 'cv_builder',
  university: 'university'
};
